/**
 * CS: Hero video unmute/mute toggle.
 * Web Component — morph-safe, scoped event handling.
 * Loaded defer from header-actions.liquid.
 */
class CsHeroUnmute extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.addEventListener('click', this.handleClick.bind(this), {
      signal: this.abort.signal,
    });
  }

  handleClick() {
    const hero = this.closest('.hero, .hero-wrapper');
    if (!hero) return;

    const video = hero.querySelector('video');
    if (!video) return;

    video.muted = !video.muted;

    const btn = this.querySelector('[data-cs-hero-unmute]');
    if (!btn) return;

    const mutedIcon = btn.querySelector('.cs-hero-unmute__icon--muted');
    const unmutedIcon = btn.querySelector('.cs-hero-unmute__icon--unmuted');

    if (video.muted) {
      mutedIcon.style.display = '';
      unmutedIcon.style.display = 'none';
      btn.setAttribute('aria-label', this.dataset.labelMute || 'Unmute video');
    } else {
      mutedIcon.style.display = 'none';
      unmutedIcon.style.display = '';
      btn.setAttribute('aria-label', this.dataset.labelUnmute || 'Mute video');
    }
  }

  disconnectedCallback() {
    this.abort?.abort();
  }
}
customElements.define('cs-hero-unmute', CsHeroUnmute);
